
<template>
    <div class="report-plus">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 82.36 82.73" style="enable-background:new 0 0 82.36 82.73;" xml:space="preserve" fill="transparent" :style="{stroke: colors.theme == 'dark' ? '#fff':'#000'}">
            <circle class="st0" cx="40.82" cy="41.37" r="39.27"/>
            <polygon class="st0" points="62.57,35.64 48.01,35.64 48.01,21.08 36.08,21.08 36.08,35.64 21.52,35.64 21.52,47.57 36.08,47.57 36.08,62.13 48.01,62.13 48.01,47.57 62.57,47.57 "/>
        </svg>
    </div>
</template>

<script>

export default {
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
    }
}
</script>

<style lang="scss" scoped>
</style>